import React from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import { Button } from '..';

const BackWrapper = styled.div`
  position: absolute;
  left: -3.5rem;
  top: 2rem;
`;

function Back() {
  const history = useHistory();

  return (
    <BackWrapper>
      <Button
        plain
        onClick={history.goBack}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="26"
          viewBox="0 0 39 32"
        >
          <path
            fill="currentColor"
            fillRule="evenodd"
            d="M15.266.403L.41 15.027a1.362 1.362 0 0 0 0 1.948l14.85 14.622a1.413 1.413 0 0 0 1.974.001l.003-.002c.547-.538.548-1.41.001-1.949L4.786 17.381h32.483c.772 0 1.398-.616 1.398-1.376v-.008c0-.76-.626-1.377-1.398-1.377H4.786L17.242 2.35A1.362 1.362 0 0 0 17.24.4a1.413 1.413 0 0 0-1.974.003"
          />
        </svg>
      </Button>
    </BackWrapper>
  );
}

export default Back;
